export const YANDEX_MAPS_API_VERSION = '2.1';

export const YANDEX_MAPS_LANG = 'ru_RU';

export const YANDEX_MAPS_DEFAULT_ZOOM = 11;

export const YANDEX_MAPS_DEFAULT_CONTROLS = ['zoomControl', 'geolocationControl', 'typeSelector'];
